import type { Ref } from 'vue'
import type { Recordable } from './type'

import {
  unref,
  reactive,
  readonly,
  watchEffect,
  computed,
  getCurrentInstance,
  nextTick,
  toRaw,
  ref
} from 'vue'

export const defaultChangeEvent = 'change'

interface Options<T extends Recordable = Recordable> {
  props: T
  key?: keyof T
  changeEvent?: string
  emitData?: Ref<any[]>
}

/**
 * 表单字段改变统一处理
 * @param props 属性对象
 * @param key 字段名
 * @param changeEvent emit发送事件
 * @param emitData 附带数据
 */

export function useFormItem({
  props,
  key = 'value',
  changeEvent = defaultChangeEvent,
  emitData = ref([])
}: Options) {
  const instance = getCurrentInstance()

  const innerState = reactive({
    value: props[key]
  })

  const immutableState = readonly(innerState)

  watchEffect(() => {
    innerState.value = props[key]
  })

  function setState(value: any) {
    innerState.value = value
  }

  const state: any = computed({
    get: () => innerState.value,
    set: (value) => {
      if (immutableState.value === value) {
        return
      }
      innerState.value = value
      nextTick(() => {
        instance?.emit?.(changeEvent, value, ...(toRaw(unref(emitData)) || []))
      })
    }
  })

  return [state, setState, immutableState]
}

useFormItem.DEFAULT_CHANGE_EVENT = defaultChangeEvent
